{"id":"Cart.TopUpBox","prefabs":{"default":{"children":[{"component":"Cart.TopUpBox","options":"options:*"}]}}}